import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/categories';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.homes';
const LOGO_URL = 'https://static.readdy.io/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

const IMAGE_URLS: Record<string, string> = {
  'vigorbuy-spreadsheet-complete-guide': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%20and%20product%20categories%20on%20screen%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20window%2C%20cream%20walls%2C%20ceramic%20coffee%20cup%20and%20small%20potted%20succulent%2C%20clean%20productive%20workspace%20atmosphere%2C%20editorial%20photography%20with%20soft%20earthy%20tones%20and%20organic%20textures&width=1200&height=600&seq=article-img-01&orientation=landscape',
  'vigorbuy-spreadsheet-safety-guide': 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20typing%20on%20laptop%20with%20security%20shield%20icon%20and%20spreadsheet%20data%20on%20screen%2C%20warm%20natural%20lighting%20from%20window%2C%20cream%20desk%20surface%20with%20coffee%20cup%2C%20small%20padlock%20symbol%20subtly%20placed%20on%20desk%2C%20editorial%20lifestyle%20photography%20with%20soft%20focus%20background%20and%20warm%20protective%20atmosphere&width=1200&height=600&seq=article-img-02&orientation=landscape',
  'vigorbuy-spreadsheet-category-guide': 'https://readdy.ai/api/search-image?query=Organized%20retail%20display%20with%20neatly%20arranged%20product%20category%20labels%20and%20sample%20items%20on%20warm%20wooden%20shelving%2C%20shoes%20handbag%20cap%20and%20accessories%20arranged%20aesthetically%2C%20golden%20afternoon%20light%20casting%20long%20soft%20shadows%2C%20boutique%20interior%20with%20cream%20walls%20and%20dried%20flowers%2C%20editorial%20product%20photography%20with%20curated%20collection%20aesthetic&width=1200&height=600&seq=article-img-03&orientation=landscape',
  'vigorbuy-spreadsheet-shopping-strategy': 'https://readdy.ai/api/search-image?query=Strategic%20shopping%20planning%20scene%20with%20open%20laptop%20showing%20spreadsheet%20on%20one%20side%20and%20handwritten%20notes%20on%20the%20other%2C%20warm%20natural%20light%20from%20large%20window%2C%20cream%20desk%20with%20organized%20highlighters%20and%20sticky%20notes%2C%20productive%20minimal%20workspace%2C%20editorial%20photography%20with%20methodical%20organized%20aesthetic%20and%20soft%20neutral%20tones&width=1200&height=600&seq=article-img-04&orientation=landscape',
  'vigorbuy-spreadsheet-product-research': 'https://readdy.ai/api/search-image?query=Closeup%20of%20person%20examining%20product%20details%20on%20laptop%20screen%20next%20to%20physical%20fashion%20items%20on%20desk%2C%20warm%20golden%20sunlight%20streaming%20across%20organized%20workspace%2C%20fabric%20swatches%20color%20palette%20cards%20and%20notebook%2C%20creative%20product%20research%20moodboard%20aesthetic%2C%20editorial%20lifestyle%20photography%20with%20thoughtful%20designer%20studio%20atmosphere&width=1200&height=600&seq=article-img-05&orientation=landscape',
  'vigorbuy-spreadsheet-comparison-guide': 'https://readdy.ai/api/search-image?query=Split%20screen%20composition%20showing%20shoes%20on%20left%20clothing%20in%20center%20and%20accessories%20on%20right%20all%20on%20warm%20cream%20surface%2C%20organized%20fashion%20comparison%20display%20with%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%20with%20harmonious%20beige%20and%20sand%20tones%2C%20boutique%20catalog%20aesthetic&width=1200&height=600&seq=article-img-06&orientation=landscape',
  'vigorbuy-spreadsheet-beginner-tips': 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20laptop%20open%20to%20spreadsheet%20view%20sticky%20notes%20with%20shopping%20tips%20handwritten%20around%20the%20workspace%2C%20warm%20morning%20sunlight%2C%20ceramic%20coffee%20mug%20and%20reading%20glasses%2C%20productive%20learning%20atmosphere%2C%20editorial%20photography%20with%20cozy%20organized%20aesthetic%20and%20soft%20cream%20tones&width=1200&height=600&seq=article-img-07&orientation=landscape',
  'vigorbuy-spreadsheet-buying-guide': 'https://readdy.ai/api/search-image?query=Complete%20shopping%20journey%20visualization%20with%20laptop%20showing%20spreadsheet%20on%20left%20shopping%20cart%20icon%20in%20center%20and%20delivered%20package%20on%20right%2C%20warm%20natural%20lighting%20throughout%2C%20cream%20minimalist%20desk%20setup%2C%20editorial%20product%20photography%20with%20clean%20narrative%20composition%20and%20soft%20beige%20tones&width=1200&height=600&seq=article-img-08&orientation=landscape',
  'vigorbuy-spreadsheet-master-guide': 'https://readdy.ai/api/search-image?query=Advanced%20professional%20workspace%20with%20dual%20monitors%20showing%20complex%20spreadsheets%20and%20product%20data%20analytics%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%20and%20natural%20window%20light%2C%20cream%20walls%20with%20minimalist%20art%20print%2C%20high%20end%20productive%20setup%20with%20mechanical%20keyboard%20and%20leather%20notebook%2C%20editorial%20photography%20with%20sophisticated%20tech%20professional%20aesthetic&width=1200&height=600&seq=article-img-09&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const article = articles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-24 md:pt-28 pb-20 text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-4">Article Not Found</h1>
          <p className="text-sm text-foreground-600 mb-6">The article you are looking for does not exist.</p>
          <Link to="/" className="px-6 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer">
            Back to Homepage
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Breadcrumb */}
      <div className="pt-20 md:pt-24 pb-0 bg-background-100">
        <div className="max-w-[860px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 py-3 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
            <span>/</span>
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">Guides</Link>
            <span>/</span>
            <span className="text-foreground-700 font-medium line-clamp-1">{article.title}</span>
          </nav>
        </div>
      </div>

      <article className="w-full pb-14 md:pb-20">
        {/* Header */}
        <header className="bg-background-100 pb-10 md:pb-14">
          <div className="max-w-[860px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <span className="px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                {article.category}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-[42px] font-heading font-bold text-foreground-900 leading-tight mb-4">
              {article.title}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              {article.excerpt}
            </p>
          </div>
        </header>

        {/* Featured Image */}
        <div className="max-w-[860px] mx-auto px-4 md:px-6 -mt-6 mb-10">
          <div className="rounded-2xl overflow-hidden h-[280px] md:h-[400px]">
            <img
              src={IMAGE_URLS[article.slug] || IMAGE_URLS['vigorbuy-spreadsheet-complete-guide']}
              alt={article.title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Content */}
        <div className="max-w-[860px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_200px] gap-10">
            {/* Main Content */}
            <div className="prose-custom">
              {/* Table of Contents */}
              <div className="bg-background-100 rounded-xl p-5 md:p-6 mb-8 border border-background-200">
                <h2 className="font-heading font-semibold text-base text-foreground-900 mb-3">Table of Contents</h2>
                <ul className="space-y-1.5">
                  {article.sections.map((section) => (
                    <li key={section.id}>
                      <a
                        href={`#${section.id}`}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {section.heading}
                      </a>
                    </li>
                  ))}
                  {article.faqs.length > 0 && (
                    <li>
                      <a
                        href="#faq"
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        Frequently Asked Questions
                      </a>
                    </li>
                  )}
                </ul>
              </div>

              {/* Sections */}
              {article.sections.map((section) => (
                <section key={section.id} id={section.id} className="mb-10">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    {section.heading}
                  </h2>
                  {section.content.map((paragraph, pIdx) => (
                    <p
                      key={pIdx}
                      className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4"
                      dangerouslySetInnerHTML={{ __html: paragraph }}
                    />
                  ))}
                </section>
              ))}

              {/* FAQ */}
              {article.faqs.length > 0 && (
                <section id="faq" className="mb-10">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                    Frequently Asked Questions
                  </h2>
                  <div className="space-y-2">
                    {article.faqs.map((faq, idx) => (
                      <div key={idx} className="border border-background-200 rounded-lg overflow-hidden">
                        <button
                          onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                          className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                        >
                          <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                          <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openFaq === idx ? 'rotate-45' : ''}`}>
                            <i className={`text-sm ${openFaq === idx ? 'text-primary-500' : 'text-foreground-400'}`}>
                              {openFaq === idx ? 'ri-subtract-line' : 'ri-add-line'}
                            </i>
                          </div>
                        </button>
                        {openFaq === idx && (
                          <div className="px-4 pb-4">
                            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {/* Conclusion */}
              <section className="mb-6">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                  Final Thoughts
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  {article.conclusion}
                </p>

                {/* CTA */}
                <div className="mt-8 p-6 rounded-xl bg-primary-50 border border-primary-200 text-center">
                  <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">Ready to Start Exploring?</h3>
                  <p className="text-sm text-foreground-600 mb-4">Browse the complete Vigorbuy Spreadsheet category collection and discover products faster than ever before.</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link to="/" className="px-6 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                      ← Back to Homepage
                    </Link>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="px-6 py-2.5 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Visit Main Website
                    </a>
                  </div>
                </div>
              </section>

              {/* Article Schema */}
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Article',
                    headline: article.title,
                    description: article.excerpt,
                    image: IMAGE_URLS[article.slug] || IMAGE_URLS['vigorbuy-spreadsheet-complete-guide'],
                    datePublished: article.date,
                    dateModified: article.date,
                    author: { '@type': 'Organization', name: 'Vigorbuy Spread', url: SITE_URL },
                    publisher: {
                      '@type': 'Organization',
                      name: 'Vigorbuy Spread',
                      url: SITE_URL,
                      logo: { '@type': 'ImageObject', url: LOGO_URL },
                    },
                    mainEntityOfPage: { '@type': 'WebPage', '@id': `${SITE_URL}guide/${article.slug}` },
                    url: `${SITE_URL}guide/${article.slug}`,
                  }),
                }}
              />
              {/* Breadcrumb Schema */}
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
                      { '@type': 'ListItem', position: 2, name: 'Guides', item: `${SITE_URL}` },
                      { '@type': 'ListItem', position: 3, name: article.title },
                    ],
                  }),
                }}
              />
            </div>

            {/* Sidebar */}
            <aside className="hidden lg:block">
              <div className="sticky top-24">
                <div className="bg-background-100 rounded-xl p-5 border border-background-200">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-3">Quick Links</h3>
                  <div className="space-y-2">
                    <Link to="/" className="block text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">← Homepage</Link>
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Vigorbuy Spreadsheet</a>
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Buy It Now</a>
                  </div>
                </div>

                {/* Related Articles */}
                <div className="bg-background-100 rounded-xl p-5 border border-background-200 mt-4">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-3">More Guides</h3>
                  <div className="space-y-2">
                    {articles.filter(a => a.slug !== slug).slice(0, 4).map((a) => (
                      <Link
                        key={a.slug}
                        to={`/guide/${a.slug}`}
                        className="block text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer line-clamp-1"
                      >
                        {a.title}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}